import { render, staticRenderFns } from "./LectureWrapper.vue?vue&type=template&id=33d363b4&scoped=true&"
import script from "./LectureWrapper.vue?vue&type=script&lang=js&"
export * from "./LectureWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LectureWrapper.vue?vue&type=style&index=0&id=33d363b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d363b4",
  null
  
)

export default component.exports